import React from 'react';
import {
  HeadlineSkeleton,
  TextSkeleton,
  ProductCardSkeleton,
  SelectFieldSkeleton,
  TextButtonSkeleton,
} from '@oneaudi/unified-web-alpha-components';
import { useMediaQuery } from 'react-responsive';
import {
  SkeletonFeaturedOffers,
  SkeletonFiltersWrapper,
  SkeletonHeaderWrapper,
  SkeletonFeaturedOffersTitle,
  SkeletonWrapper,
  SkeletonFeaturedOffersSelector,
} from './Skeleton.styles';
import { device } from '../../app/styles/devices';

const SkeletonLoader: React.FC = () => {
  const isLaptop = useMediaQuery({ query: device.laptop });

  return (
    <div style={{ flex: 1 }}>
      <SkeletonWrapper>
        <SkeletonHeaderWrapper>
          <HeadlineSkeleton order="4" className="title" data-testid="skeleton-title" />
          <HeadlineSkeleton order="1" className="header" data-testid="skeleton-header" />
          <TextSkeleton
            order="1"
            lines={isLaptop ? 2 : 5}
            className="description"
            data-testid="skeleton-description"
          />
        </SkeletonHeaderWrapper>
        <SkeletonFiltersWrapper>
          <TextButtonSkeleton size="md" className="skipTo" data-testid="skeleton-skipTo" />
        </SkeletonFiltersWrapper>
        <SkeletonFeaturedOffersTitle>
          <HeadlineSkeleton order="1" className="title" data-testid="skeleton-featured-title" />
        </SkeletonFeaturedOffersTitle>
        {!isLaptop && (
          <SkeletonFeaturedOffersTitle>
            <SelectFieldSkeleton className="selector" data-testid="skeleton-selector" />
          </SkeletonFeaturedOffersTitle>
        )}
        <SkeletonFeaturedOffers>
          <ProductCardSkeleton className="tile" data-testid="skeleton-tile" />
        </SkeletonFeaturedOffers>
        {isLaptop && (
          <SkeletonFeaturedOffersSelector>
            <SelectFieldSkeleton className="selector" data-testid="skeleton-selector" />
          </SkeletonFeaturedOffersSelector>
        )}
      </SkeletonWrapper>
    </div>
  );
};

export default SkeletonLoader;
